<template>
  <div class="medical-notes-wrapper">
    <table>
      <thead>
        <tr>
          <th>Guests</th>
          <th>Medical conditions</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="`${row.guestName}-${row.condition || 'no-conditions'}`"
        >
          <td>{{ row.guestName }}</td>
          <template v-if="row.hasConditions">
            <td>{{ row.condition }}</td>
            <td>{{ row.details }}</td>
          </template>
          <template v-else>
            <td colspan="2">
              No conditions or requirements declared
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MedicalNotesTable',

  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  computed: {
    rows () {
      if (!this.payload) return []

      return Object.entries(this.payload).flatMap(([guestName, conditionsObj]) => {
        const conditions = Object.entries(conditionsObj || {})

        if (conditions.length === 0) {
          return [{
            guestName,
            hasConditions: false
          }]
        }

        return conditions.map(([condition, details]) => ({
          guestName,
          condition,
          details,
          hasConditions: true
        }))
      })
    }
  }
}
</script>

<style scoped>
table th:nth-child(-n+3) {
  border-right: 1px solid var(--alt-font-color);
}

table td:nth-child(3) {
  overflow-wrap: break-word;
}
</style>
